// extracted by mini-css-extract-plugin
export default {"input":"UploadImg_input__n+M7u","img":"UploadImg_img__vaSs7","pdf":"UploadImg_pdf__qXFB0"};